module.exports = __webpack_public_path__ + "static/media/icoNext.b3854959.svg";